import React from 'react';
import {MuiButton, MuiHidden,MuiMoneyIcon, MuiDrawer, MuiList, MuiListItem, MuiPeopleIcon,MuiTypography, MuiGrid, MuiChevronRight, MuiIconButton, MuiDivider, MuiFab } from '../MaterialUIComponents';
import {Link} from 'react-router-dom'
import routes from '../../navigation/Routes';
import { colorPalatte } from '../../../assests/theme';
import theme from '../../../assests/theme'

const SideNav=(props)=>{
    const {
        direction,
        style= elementStyles,
        content = DefaultSideNavContent,
        }=props;
    return(props.cognitoUser != null ?
        
            <MuiDrawer
                anchor={direction}
                open={props.right} 
                onClose={(event)=>props.toggleDrawer('right', false,props.ContextualHelp)(event)}>
             <div style={style.container}>
              {React.createElement(content, {...props})}
             </div>
                </MuiDrawer>
        :<div></div>
    )
}

const DefaultSideNavContent=(props)=>{
    return(
        <MuiGrid container direction="column">
            <MuiGrid container item style={{border: '1px solid ' + theme.palette.grey.dark, borderBottom: 'none',background: theme.palette.primary.main, padding: 8 }} justify="center" alignItems="center">
            <MuiTypography style={{fontFamily: "Arial", fontWeight: 600, fontSize: "18px", letterSpacing: "0.36px", padding: 2, color: "#FFFFFF" }} >
                  Help Center
                </MuiTypography>
            </MuiGrid>
            <MuiGrid item style={{padding:'5px'}}>
                {props.ContextualHelp.map((help) => <MuiGrid item><MuiTypography style={theme.typography.h7}>
                {help.Title}
            </MuiTypography><MuiTypography style={theme.typography.body1} >
                <span dangerouslySetInnerHTML={{__html:help.Body}}></span>
            </MuiTypography><MuiDivider style={{marginTop:'5px', marginBottom:'5px'}}/></MuiGrid>)}
            </MuiGrid>
        </MuiGrid>

    )
}
const elementStyles={
    container: {
        flex:1,
        flexDirection: 'column',
        marginTop:'0px'
        ,width: 250
    }
}
export default SideNav;